import * as React from 'react';
import { classNames, ScriptLoader } from 'uitk-react-utils';
import styles from './uitk-video.css';
import { useVideoHook } from './uitk-video-custom-hook.esm.js';
import { getVideoId } from './uitk-video-helper.esm.js';
import { UitkVideoLayer } from './uitk-video-layer.esm.js';

// Exclude this file from Jest due to testing issues on hooks. Will have to circle back on this.
var getClassNameList = classNames.bind(styles);
var UitkVideo = function (_a) {
    var alt = _a.alt, analytics = _a.analytics, className = _a.className, isDialog = _a.isDialog, src = _a.src, buttonText = _a.buttonText;
    var _b = useVideoHook(analytics), playerError = _b.playerError, onPlayerError = _b.onPlayerError, isPlayerReady = _b.isPlayerReady, onPlayerReady = _b.onPlayerReady, playerState = _b.playerState, onPlayerStateChange = _b.onPlayerStateChange, player = _b.player, setPlayer = _b.setPlayer, onClickPlay = _b.onClickPlay, onClickPause = _b.onClickPause;
    var videoId = getVideoId(src);
    var _c = React.useState(videoId), playerVideoId = _c[0], setPlayerVideoId = _c[1];
    var wrapperVideoClassNames = getClassNameList('uitk-video', className);
    var updatePlayerVideo = function () {
        if (isPlayerReady) {
            setPlayerVideoId(videoId);
            // @ts-ignore
            player.cueVideoById(videoId);
        }
    };
    /* istanbul ignore next */
    var createPlayer = function () {
        window.YT.ready(function () {
            setPlayer(new window.YT.Player("player-".concat(videoId).concat(isDialog ? '-dialog' : ''), {
                events: {
                    onError: onPlayerError,
                    onReady: onPlayerReady,
                    onStateChange: onPlayerStateChange
                },
                height: '100%',
                playerVars: {
                    controls: 1,
                    disablekb: 1,
                    enablejsapi: 1,
                    iv_load_policy: 3,
                    modestbranding: 1,
                    rel: 0
                },
                videoId: videoId,
                width: '100%'
            }));
        });
    };
    React.useEffect(function () {
        var mounted = true;
        if (!window.YT) {
            ScriptLoader.getScript("https://www.youtube.com/iframe_api")
                .then(function () {
                if (mounted) {
                    createPlayer();
                }
            })
                .catch(function (err) {
                console.error(err);
            });
        }
        else if (!player) {
            createPlayer();
        }
        else if (videoId !== playerVideoId) {
            updatePlayerVideo();
        }
        return function () {
            mounted = false;
        };
    });
    if (typeof document === 'undefined') {
        return null;
    }
    return (React.createElement("div", { className: wrapperVideoClassNames },
        React.createElement(UitkVideoLayer, { alt: alt || '', controls: {
                pause: onClickPause,
                play: onClickPlay
            }, buttonText: buttonText, isPlayerReady: isPlayerReady, playerError: playerError, playerState: playerState, src: src }),
        React.createElement("div", { id: "player-".concat(videoId).concat(isDialog ? '-dialog' : '') })));
};

export { UitkVideo };
